export const getAnalytics = (search_request?: string, сount = 0) => {
  return {
    open: {
      eventName: 'sport_searchResult',
      data: {
        сount,
        search_request,
      },
    },
  };
};
